import React from "react";
import { Wrapper } from "./TextArea.styled";

export const TextArea = ({
  value,
  onChange,
  className,
  type = "text",
  placeholder,
  ...props
}) => {
  return (
    <Wrapper
      value={value}
      className={className}
      onChange={onChange}
      type={type}
      placeholder={placeholder}
      
      {...props}
    />
  );
};
